import { useEffect } from "react";
import { auth } from "firebase/app";
import { toastr } from "react-redux-toastr";

export const useSignInAnonymously = (semaphore?: boolean) => {
  useEffect(() => {
    if (semaphore) {
      auth().signInAnonymously()
        .catch(({ message }) => {
          toastr.error("Firebase Sign-In", message);
        });
    }
  }, [semaphore]);
};
